import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PrivateRoute, PublicRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})


//Features
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController'),
})

// Settings
const ViewTransferSettingsController = LoadableRoute({
    loader: () => import('../components/features/settings/transfer/controllers/viewSettingsController'),
})

// Info
const InfoController = LoadableRoute({
    loader: () => import('../components/features/info/controllers/infoController'),
})

// Update
const UpdateTransferSettingsController = LoadableRoute({
    loader: () => import('../components/features/settings/transfer/controllers/updateSettingsController'),
})

//ListTransfer
const ListTransferController = LoadableRoute({
    loader: () => import('../components/features/transfer/controllers/listTransferController'),
})

//CreateTransfer
const CreateTransferController = LoadableRoute({
    loader: () => import('../components/features/transfer/controllers/createTransferController'),
})


//TransferRequest
const TransferRequestController = LoadableRoute({
    loader: () => import('../components/features/transfer/controllers/transferRequestController'),
})

//ReceiveTransfer
const ReceiveTransferController = LoadableRoute({
    loader: () => import('../components/features/transfer/controllers/receiveTransferController'),
})

//ViewTransfer
const ViewTransferController = LoadableRoute({
    loader: () => import('../components/features/transfer/controllers/viewTransferController'),
})

// PO Receipt
const POReceiptController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/poReceiptController'),
})


// Print Tag
// RM Tag
const RmTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/rmTagController'),
})

// PD Tag
const PdTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/controllers/pdTagController'),
})

// Delivery Tag
const DeliveryTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/deliveryTag/controllers/searchDeliveryTagController'),
})


const ListSearchDeliveryTagController = LoadableRoute({
    loader: () => import('../components/features/qrtag/deliveryTag/controllers/listDeliveryTagController'),
})


// SO Pick
const PickController = LoadableRoute({
    loader: () => import('../components/features/pickPack/controllers/pickPackControllers'),
})

// SO Detail
const PickDetailController = LoadableRoute({
    loader: () => import('../components/features/pickPack/controllers/pickPackInfoControllers'),
})

// Print
const PrintTemplateController = LoadableRoute({
    loader: () => import('../components/features/print/printTemplateController'),
})

// Change Raw Matertial
const ListChangeRawMatController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/singlePd/lists/controllers/listChangeRawMatController'),
})

const CreateChangeRawMatController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/singlePd/create/controllers/createChangeRawMatController'),
})

const ViewChangeRawMatController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/singlePd/view/controllers/viewChangeRawMatController'),
})

// Multi-PD
const ListMultiPDController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/multiPD/list/controllers/listMultiPdController'),
})
const CreateMultiPController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/multiPD/create/controllers/createMultiPdControllers'),
})
const ViewMultiPController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/multiPD/view/controllers/viewMultiPdControllers'),
})

// RM SUMMARY
const ListRMSummaryDController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/rmSummary/list/controllers/listRmSummaryController'),
})
const CreateRMSummaryDController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/rmSummary/create/controllers/createRmSummaryController'),
})
const ViewRMSummaryDController = LoadableRoute({
    loader: () => import('../components/features/changeRawMaterial/rmSummary/view/controllers/viewRmSummaryController'),
})

const LandingSettings = LoadableRoute({
    loader: () => import('../components/features/settings/landingSettings'),
})

//User
const UserManageSubmitController = LoadableRoute({
    loader: () => import('../components/features/settings/user/controllers/userManageSubmitController'),
})

const UserManageApproveController = LoadableRoute({
    loader: () => import('../components/features/settings/user/controllers/userManageApproveController'),
})

const UserListController = LoadableRoute({
    loader: () => import('../components/features/settings/user/controllers/userListController'),
})


export default () => (
    <Switch>

        <PrivateRoute path='/deliverytag/:date/:itemId/:batchNumber/:so' component={ListSearchDeliveryTagController} layout={LayoutMaster} />
        <PrivateRoute path='/deliverytag/:date/:itemId/:batchNumber' component={ListSearchDeliveryTagController} layout={LayoutMaster} />
        <PrivateRoute path='/deliverytag/:itemId/:batchNumber' component={ListSearchDeliveryTagController} layout={LayoutMaster} />

        <PrivateRoute path='/rmsummary/view/:id' component={ViewRMSummaryDController} layout={LayoutMaster} />
        <PrivateRoute path='/multipd/view/:id' component={ViewMultiPController} layout={LayoutMaster} />
        <PrivateRoute path='/rawmaterial/view/:id' component={ViewChangeRawMatController} layout={LayoutMaster} />
        <PrivateRoute path='/transfer/view/:id' component={ViewTransferController} layout={LayoutMaster} />
        <PrivateRoute path='/transfer/receive/:id' component={ReceiveTransferController} layout={LayoutMaster} />
        <PrivateRoute path='/transfer/request/:id' component={TransferRequestController} layout={LayoutMaster} />
        <PrivateRoute path='/settings/transfer/update' component={UpdateTransferSettingsController} layout={LayoutMaster} />
        <PrivateRoute path='/settings/users/managesubmit' component={UserManageSubmitController} layout={LayoutMaster} />
        <PrivateRoute path='/settings/users/manageapprove' component={UserManageApproveController} layout={LayoutMaster} />

        <PrivateRoute path='/rmsummary/create' component={CreateRMSummaryDController} layout={LayoutMaster} />
        <PrivateRoute path='/multipd/create' component={CreateMultiPController} layout={LayoutMaster} />
        <PrivateRoute path='/rawmaterial/create' component={CreateChangeRawMatController} layout={LayoutMaster} />
        <PrivateRoute path='/transfer/create' component={CreateTransferController} layout={LayoutMaster} />
        <PrivateRoute path='/settings/users' component={UserListController} layout={LayoutMaster} />
        <PrivateRoute path='/settings/transfer' component={ViewTransferSettingsController} layout={LayoutMaster} />
        <PrivateRoute path='/pack/:so' component={PickDetailController} layout={LayoutMaster} />

        <PrivateRoute path='/rmsummary' component={ListRMSummaryDController} layout={LayoutMaster} />
        <PrivateRoute path='/multipd' component={ListMultiPDController} layout={LayoutMaster} />
        <PrivateRoute path='/rawmaterial' component={ListChangeRawMatController} layout={LayoutMaster} />
        <PrivateRoute path='/pack' component={PickController} layout={LayoutMaster} />
        <PrivateRoute path='/deliverytag' component={DeliveryTagController} layout={LayoutMaster} />
        <PrivateRoute path='/pdtag' component={PdTagController} layout={LayoutMaster} />
        <PrivateRoute path='/rmtag' component={RmTagController} layout={LayoutMaster} />
        <PrivateRoute path='/poreceipt' component={POReceiptController} layout={LayoutMaster} />
        <PrivateRoute path='/print' component={PrintTemplateController} layout={LayoutMaster} />
        <PrivateRoute path='/transfer' component={ListTransferController} layout={LayoutMaster} />
        <PrivateRoute path='/settings' component={LandingSettings} layout={LayoutMaster} />

        {/* <PrivateRoute exact path='/masterData/settings' component={HomeController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterData' component={HomeController} layout={LayoutMaster} />*/}

        <PrivateRoute path='/info' component={InfoController} layout={LayoutMaster} />
        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutMaster} />

        <PrivateRoute exact path='/:mode' component={HomeController} layout={LayoutMaster} />
        <PrivateRoute exact path='/' component={HomeController} layout={LayoutMaster} />

        <PublicRoute component={NotFoundController} layout={LayoutMaster} />

    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js